import { Component } from 'preact'
import { Stars, ReviewForm, Modal } from '../'
import i18n from '../../i18n'
import { getInitialState } from '../../helpers/state'
import { auth } from '../helpers'

const LIMIT = 3
const LOADING = 'loading'
const LOADED = 'loaded'
const OPEN = 'open'
const CLOSED = 'closed'
const CLASS = 'mv-comments'

/**
 * Forces an array of objects to be unique based on "id" key
 */
const unique = arr => arr.reduce((all, one) => {
  if (all.some(({ id }) => one.id == id)) { // eslint-disable-line
    return all
  }
  return [...all, one]
}, [])

class SingleComments extends Component {
  constructor(props) {
    super(props)

    // Derive initial data used by form from local storage
    this.initialData = getInitialState(props.id)

    this.state = {
      // Default to page 2 since we're preloading data
      page: 2,
      localRating: null,
      status: LOADED, // loading, loaded
      modal: CLOSED, // open
    }

    this.getComments = this.getComments.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.handleStarClick = this.handleStarClick.bind(this)
    this.handleUpdateRatings = this.handleUpdateRatings.bind(this)
  }

  /**
   * Fetches the next page of comments
   */
  async getComments() {
    const { page } = this.state

    this.setState({ status: LOADING })

    // Get data
    const { data } = await auth.get(
      `mv-create/v1/reviews?creation=${this.props.data.id}&page=${page}&limit=${LIMIT}`,
    )

    // Update data
    this.setState(state => ({
      page: state.page + 1,
      status: LOADED,
    }))

    // Trigger onload callback
    this.props.onLoad(...data)
  }

  /**
   * Opens form modal
   * @param {*} e
   */
  handleOpen(e) {
    e.preventDefault()
    this.setState({ modal: OPEN })
  }

  /**
   * Open model and update local rating when a star is clicked
   * @param {number} localRating
   */
  handleStarClick(localRating) {
    this.setState({
      localRating,
      modal: OPEN,
    })
  }

  /**
   * Callback after form submission. We close the modal and update ratings.
   * @param {number} rating    New rating
   * @param {object} previous  Locally-cached rating
   */
  handleUpdateRatings(review) {
    this.setState({ modal: CLOSED })
    if (this.initialData) {
      const { id, onUpdate } = this.props
      onUpdate(id, review)
    } else {
      const { id, onAdd } = this.props
      onAdd(id, review)
    }
  }

  render() {
    const { data } = this.props
    const { status, modal, localRating } = this.state

    if (data.reviews.length === 0) {
      return null
    }

    return (
      <div class={`${CLASS}-card`}>

        <header class={`${CLASS}-card-header`}>

          <h2 class={`${CLASS}-card-heading`}>
            {data.total > 1 ? i18n('X_REVIEWS_FOR')(data.total, data.title) : i18n('X_REVIEW_FOR')(data.total, data.title)}
          </h2>

          <div class={`${CLASS}-card-stars`}>
            <Stars rating={data.rating} onClick={this.handleStarClick} />

            {i18n('NUM_STARS')(parseFloat(data.rating).toFixed(1))}

            <div class={`${CLASS}-card-stars-divider`} />

            <a href="#" onClick={this.handleOpen}>
              {i18n('LEAVE_REVIEW')}
            </a>
          </div>

        </header>

        {unique(data.reviews)
          .map(comment => (
            <div class={`${CLASS}-review`}>
              <div class={`${CLASS}-review-author`}>
                {comment.author_name || <span class={`${CLASS}-placeholder`}>{i18n('ANONYMOUS_USER')}</span>}
              </div>
              <div class={`${CLASS}-review-date`}>
                <time>
                  {new Date(comment.created * 1000).toLocaleString()}
                </time>
              </div>
              <div class={`${CLASS}-review-stars`}>
                <Stars rating={comment.rating} clickable={false} />
                {comment.review_title && <h3>{comment.review_title}</h3>}
              </div>
              {comment.review_content && (
                <div>{comment.review_content}</div>
              )}
            </div>
          ))}

        <footer class={`${CLASS}-loadmore`}>
          {data.reviews.length < data.total && (
            <button onClick={this.getComments}>
              {status === LOADING ? i18n('LOADING') : i18n('VIEW_MORE')}
            </button>
          )}
        </footer>

        {modal === OPEN && (
          <Modal onClose={() => this.setState({ modal: CLOSED })}>
            <ReviewForm
              id={data.id}
              rating={localRating}
              onSubmit={this.handleUpdateRatings}
            />
          </Modal>
        )}
      </div>
    )
  }
}

export default SingleComments
